import { Viewports } from "../../store/enums";

const defaultOptions = {
  breakpoints: {
    mobile: 1,
    tablet: 2,
    laptop: 3,
    desktop: 4,
  },  
  arrowsVisible: true,
  indicatorVisible: true,
};

class Carousel {
  constructor(DOMelement, store, options = {}) {
    try {
      this.el = DOMelement;
      if(this.el == null){return;}
      this.store = store;
      this.options = { ...defaultOptions, ...options };
      this.currentSlide = 0;
      this.activeSlide = this.options.activeSlide ? this.options.activeSlide : 1;
      this.slideDuration = this.options.slideDuration ? this.options.slideDuration : 5000;

      this.carouselWrapper = this.el.querySelector(".sd-carousel__wrapper");
      this.items = this.el.querySelectorAll(".sd-carousel__wrapper > li");
      this.previousButton = this.el.querySelector(".sd-carousel__previous");
      this.nextButton = this.el.querySelector(".sd-carousel__next");
      this.indicatorWrapper = this.el.querySelector(".sd-carousel__indicator");

      this.viewport = store.getState().viewport;
      this.itemsPerSlide = this.getItemsPerSlide(this.store.state.viewport);
      this.totalItems = this.items.length;
      this.totalSlides = Math.ceil(this.totalItems / this.itemsPerSlide);
      this.setActiveSlide = this.setActiveSlide.bind(this);
      this.offsetSlide = this.offsetSlide.bind(this);

      this.autoSlide = this.autoSlide.bind(this);
      if (this.totalSlides === 1) {
        this.carouselWrapper.style.justifyContent = "center";
      }

      if (this.totalSlides > 1 && this.previousButton) {
        this.previousButton.addEventListener("click", () => {
          this.offsetSlide(-1);
        });
      }
      if (this.totalSlides > 1 && this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          this.offsetSlide(1);
        });
      }
      if (this.totalSlides > 1){
        this.carouselWrapper.addEventListener("scroll", this.handleScroll.bind(this));
        this.store.subscribeValue("viewport", (viewport) => {
          if (viewport === store.getState().viewport) {
            this.resetCarousel(viewport);
          }
        });
      }
      if(this.viewport === 'mobile'){
        this.touchSwipe();
      }

      this.addIndicators = this.addIndicators.bind(this);
      this.setActiveIndicator = this.setActiveIndicator.bind(this);
      this.setArrowVisibility = this.setArrowVisibility.bind(this);
      this.setSlideWidths = this.setSlideWidths.bind(this);
      this.resetCarousel(this.viewport);

      if(this.options.autoplay === true){
        this.autoSlide();        
      }
    }catch (error) {
      console.log(error);
    }
  }

  touchSwipe(){
    let startX,
        endX;
    this.el.addEventListener("touchstart",(e) => {
      const touch = e.touches[0];
      startX = touch.pageX;
    })
    this.el.addEventListener("touchend",(e) => {
      const touch = e.changedTouches[0];
      endX = touch.pageX;
      const diffX = endX - startX;
      if (diffX > 0) {
        //swipe right statement;
        if (this.currentSlide  === 0){
          //begining of slider;
          this.offsetSlide(-1);
        }
      } else if(diffX < 0) {
        //swipe left statement;
        if (this.currentSlide + 1 === this.totalSlides){
          //end of slider;
          this.offsetSlide(1);
        }
      }
    })
  }

  autoSlide() {
    setInterval(() => {
      this.offsetSlide(1);
    }, this.slideDuration);
  }

  setSlideWidths() {
    this.items.forEach((element, index) => {
      if(this.itemsPerSlide > 1){
        element.style.width = `${100 / this.itemsPerSlide}%`;
      }
      element.style.scrollSnapAlign = index % this.itemsPerSlide === 0 ? "start" : "none";
    });
  }

  setArrowVisibility() {
    if (!this.options.arrowsVisible || this.totalSlides == 1) {
      this.nextButton.remove();
      this.previousButton.remove();
      return;
    }
    if (this.totalSlides <= 1) {
      this.el.classList.remove("arrows-visible");
    } else {
      this.el.classList.add("arrows-visible");
    }
  }

  setActiveSlide(currSlide) {
    const activeClass = this.carouselWrapper.querySelector("li.active");
    if (activeClass) {
      activeClass.classList.remove("active");
    }

    const nextSlide = this.carouselWrapper.querySelector(`li:nth-child(${this.activeSlide + currSlide})`);
    if (this.options.activeSlide && nextSlide) {
      nextSlide.classList.add("active");
    }
  }

  addIndicators() {
    const indicator = document.createElement("ul");
    indicator.classList.add('sd-carousel__indicator');
    if (!this.options.slideCount) {
      if (!this.options.indicatorVisible || this.totalSlides <= 1) {
        return;
      }
    } else {
      if (!this.options.indicatorVisible || this.totalItems <= 1) {
        return;
      }
    }
    if (!this.options.slideCount) {
      for (let index = 0; index < this.totalSlides; index++) {
        const indicatorItem = document.createElement("li");
        indicatorItem.className = "sd-carousel__indicator-item";
        indicator.appendChild(indicatorItem);
        indicatorItem.addEventListener("click", () => {
          this.setSlide(index, indicator);
        });
      }
    } else {
      for (let index = 0; index <= (this.totalItems - this.itemsPerSlide); index++) {
        const indicatorItem = document.createElement("li");
        indicatorItem.className = "sd-carousel__indicator-item";
        indicator.appendChild(indicatorItem);
        indicatorItem.addEventListener("click", () => {
          this.setSlide(index);
        });
      }
    }
    const removeIndicator = this.el.querySelector(".sd-carousel__indicator");
    if(removeIndicator) {
      removeIndicator.remove();
    }
    this.el.appendChild(indicator);
  }

    setActiveIndicator(activeIndex) {
        const indicator = this.el.querySelector(".sd-carousel__indicator");
        if (indicator) {
            const active = indicator.querySelector(".active");
            if (active) { active.classList.remove("active"); }
            let next = indicator.querySelector(`li:nth-child(${activeIndex + 1})`);
            if (next) { next.classList.add("active"); }
        }

        // Always display both the next and previous buttons
        this.previousButton.style.display = "block";
        this.nextButton.style.display = "block";
    }

  getItemsPerSlide(viewport) {
    for (const port in Viewports) {
      if(Viewports[port] === viewport){
        return this.options.breakpoints[viewport];
      }
    }
  }

  resetCarousel(viewport) {
    this.viewport = viewport;
    this.itemsPerSlide = this.getItemsPerSlide(this.store.state.viewport);
    this.totalSlides = Math.ceil(this.items.length / this.itemsPerSlide);
    this.setSlideWidths();
    if(!this.indicatorWrapper) {
      this.addIndicators();
    } else {
      [...this.indicatorWrapper.children].forEach((indicator, index) => {
        indicator.addEventListener("click", (i) => {
          this.setSlide(index);
          this.setActiveSlide(index);
        });
      })
    }
    this.setArrowVisibility();
    this.setActiveIndicator(this.currentSlide);
    this.setActiveSlide(this.currentSlide);

    if (this.currentSlide > this.totalSlides - 1) {
      this.setSlide(this.totalSlides - 1);
    }
  }

  animate() {
    const itemWidth = this.carouselWrapper.scrollWidth / this.totalItems;
    const slideWidth = itemWidth * this.itemsPerSlide;
    let value;
    if (!this.options.slideCount) {
      value = this.currentSlide * slideWidth;
    } else {
      value = this.currentSlide * itemWidth;
    }
    this.carouselWrapper.scrollLeft = value;
  }

  setSlide(currIndex) {
    this.currentSlide = currIndex;
    this.setActiveSlide(currIndex);
    this.setActiveIndicator(currIndex);
    this.animate();
  }

  offsetSlide(offset) {
    let currIndex = this.currentSlide + offset;
    if (!this.options.slideCount) {
      if (currIndex >= this.totalSlides) {
        currIndex = 0;
      }
      if (currIndex < 0) {
        currIndex = this.totalSlides - 1;
      }
    } else {
      if (currIndex >= this.totalItems) {
        currIndex = 0;
      }
      if (currIndex < 0) {
        currIndex = this.totalItems - 1;
      }
    }

    this.setSlide(currIndex);
  }

  handleScroll(event) {
    const carousel = event.target;
    const scrollPosition = carousel.scrollLeft;
    const itemWidth = carousel.scrollWidth / this.totalItems;
    const slideWidth = Math.floor(itemWidth * this.itemsPerSlide);

    let newSlide;
    if (!this.options.slideCount) {
      newSlide = Math.round(scrollPosition / slideWidth);
    } else {
      newSlide = Math.round(scrollPosition / itemWidth);
    }

    if (this.totalItems % this.itemsPerSlide !== 0) {
      if (!this.options.slideCount) {
        if (Math.floor(scrollPosition + slideWidth) > (this.totalSlides - 1) * slideWidth) {
          newSlide = this.totalSlides - 1;
        }
      } else {
        if (Math.floor(scrollPosition + slideWidth) > (this.totalItems - 1) * slideWidth) {
          newSlide = this.totalItems - 1;
        }
      }
    }
    if (newSlide !== this.currentSlide) {
      this.currentSlide = newSlide;
      this.setActiveIndicator(newSlide);
    }
  }
}

export default Carousel;